import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { applyDiscountCode } from "actions/account/subscription";
import { useGlobalContext } from "context/global";

const DiscountForm = ({ data, className = {} }) => {
	const {
		translation,
		cartSettings: { subscription },
		subscriptionRules: { commitmentBasedDiscounts, timeLimitedDiscounts },
	} = useGlobalContext();
	const { metafields } = useSelector(state => state.account.profile);
	const { shopifyClient } = useSelector(state => state.global);
	const { id } = useSelector(state => state.account.profile);

	const [discountCode, setDiscountCode] = useState("");
	const [loading, setLoading] = useState(false);
	const [isFocused, setIsFocused] = useState(false);
	const dispatch = useDispatch();

	const handleApplyDiscount = useCallback(async (e) => {
		e.preventDefault();
		if (discountCode.toLowerCase().includes("amount_off")) {
			toast.error("Coupon code is not valid");
			return;
		}

		if (!discountCode) {
			toast.error("Please enter a coupon code");
			return;
		}

		setLoading(true);

		try {
			const hasRemovedDiscount = [metafields, subscription.discountCode].some(field =>
				Array.isArray(field) ? field.some(mf => mf?.value.includes(discountCode)) : field === discountCode
			);

			if (hasRemovedDiscount) {
				toast.error(translation.subscription.manage_coupon.coupon_not_valid);
				return;
			}

			const response = await dispatch(applyDiscountCode(discountCode));
			if (response.success) {
				toast.success(`${discountCode}  ${translation.subscription?.manage_coupon.has_been_applied}`);
				const matchedDiscount = commitmentBasedDiscounts?.find(commitment => commitment?.title === discountCode) ||
					timeLimitedDiscounts?.find(limited => limited === discountCode);
				if (matchedDiscount)
					shopifyClient.customer.updateMetafields("applied_discounts", discountCode, id, metafields);
			} else {
				toast.error(response?.code === "DISCOUNT_FORBIDDEN" ?
					translation.subscription.manage_coupon.coupon_not_valid :
					response.message);
			}
		} finally {
			setLoading(false);
			setDiscountCode("");
		}
	}, [discountCode]);

	return (
		<form
			onSubmit={handleApplyDiscount}
			className={className.form || "flex flex-row justify-center w-full gap-3 md:gap-5 flex-wrap m-auto px-5 pb-5 mt-5 md:mt-10"}
		>
			<input
				type="text"
				value={discountCode}
				required
				onChange={(e) => setDiscountCode(e.target.value)}
				className={className.input ||
					"border-secondary border-[0.5px] p-4 text-sm w-full md:w-1/3 h-11 overflow-visible whitespace-nowrap"}
				placeholder={data?.inputPlaceholder}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				style={isFocused ? { borderColor: "#7C7C7C", boxShadow: "none", outline: "initial" } : undefined}
			/>
			<button
				type="submit"
				className={className.button || "btn-primary w-full md:w-1/3 md:px-5 lg:px-10 md:h-11"}
			>
				{loading ? `${translation.other.loading}...` : data?.buttonText}
			</button>
		</form>
	);
};

export default DiscountForm; 